import axios from "axios";
import { GET_WORKINGDETAILS_BY_STUDENTID } from "./types";
const keys = require("../config/keys");

export const getWorkingInstituteDetailsByStudentId = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetWorkingInstituteDetailsByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_WORKINGDETAILS_BY_STUDENTID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getWorkingInstituteDetailsByStudentId.js